/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: { location_id: props.location_id },
    pause: !props.location_id,
  }
}
